<template>
  <Dialog header="Password" class="password-modal" modal v-model:visible="isOpened"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '25vw' }">
    <form @submit.prevent="onSubmit(!v$.$invalid)">
      <!-- :class="{'display-none': isLoadingGetData}" -->

      <f7-row>
        <f7-col>
          <h4>Change Password</h4>

          <p>Here you can set new password — min 6, max 32 characters and contains no spaces.</p>

       

          <div class="p-input-group">
            <span class="p-float-label p-mt-5">
              <InputText id="lastname" class="w-100" type="text" v-model="lastNameVal" />
              <label for="lastNameVal" :class="{ 'p-error': v$.lastNameVal.$invalid && isSubmitted }">{{
                  $t("Current password")
              }}</label>
            </span>
            <small v-if="
              (v$.lastNameVal.$invalid && isSubmitted) ||
              v$.lastNameVal.$pending.$response
            " class="p-error">{{
    v$.lastNameVal.required.$message.replace(
      "Value",
      $t("Current password")
    )
}}</small>
          </div>
          <div class="p-input-group">
            <span class="p-float-label p-mt-5">
              <InputText id="email" class="w-100" type="text" v-model="v$.emailVal.$model" />
              <label :class="{ 'p-error': v$.emailVal.$invalid && isSubmitted }" for="email">New password</label>
            </span>
            <small v-if="
              (v$.emailVal.$invalid && isSubmitted) ||
              v$.emailVal.$pending.$response
            " class="p-error">{{ v$.emailVal.email.$message.replace("Value", "New password") }}</small>
          </div>
          <div class="p-input-group">
            <span class="p-float-label p-mt-5">
              <InputNumber class="w-100" id="mobile" v-model="v$.mobile.$model" mode="decimal" :useGrouping="false"
                :class="{ 'p-invalid': v$.mobile.$invalid && isSubmitted }" />
              <label for="mobile" :class="{ 'p-error': v$.mobile.$invalid && isSubmitted }">{{ $t("Confirm Password")
              }}</label>
            </span>
            <small v-if="
              (v$.mobile.$invalid && isSubmitted) ||
              v$.mobile.$pending.$response
            " class="p-error">{{
    v$.mobile.required.$message.replace(
      "Value",
      $t("Confirm Password")
    )
}}</small>
          </div>
        </f7-col>

        
      </f7-row>
    </form>

    <template #footer>
      <Divider />
      <f7-row>
   
        <f7-col>
          <Button :label="$t('COM_MSG062')" class="w-100 p-ml-0 button-form p-button-sm"
            @click="onSubmit(!v$.$invalid)" />
        </f7-col>
      </f7-row>

      <!-- :class="{'disabled': isLoadingGetData || isLoading}" -->
    </template>
  </Dialog>
</template>


<script>
import { useStore } from "vuex";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import Tooltip from "primevue/tooltip";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import { email, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { useI18n } from "vue-i18n";
import Divider from "primevue/divider";
import CountryService from "../../service/country-service";
import TimeZoneService from "../../service/time-zone-service";
import CustomersService from "../../service/customers-service";


import { sortArrayByObjProps } from "../../js/helper";

import { ref, onMounted, computed, reactive, watch, watchEffect } from "vue";
import _ from "lodash";

export default {
  name: "profile-modal",

  components: {
    Dialog,
    Button,
    InputText,
    InputNumber,
    Divider,
    Dropdown,
  },
  props: {
    isOpened: { type: Boolean, default: false },
  },
  emits: ["update:isOpened", "statusChanged"],
  directives: {
    tooltip: Tooltip,
  },

  setup(props, { emit }) {
    const { t } = useI18n();
    const store = useStore();
    const MinorToken = computed(() => store.getters.MinorToken);
    const MajorToken = computed(() => store.getters.MajorToken);
    const UserInfo = computed(() => store.getters.UserInfo);
    const Info = computed(() => store.getters.info);
    const countryService = ref(new CountryService());
    const countries = ref();

    onMounted(() => {
    
      countries.value = countryService.value.getCountries();
      countries.value =
        countries.value && countries.value.length
          ? sortArrayByObjProps(countries.value, [
            { prop: "Country", direction: 1 },
          ])
          : [];
      timeZones.value = timeZoneService.value.getTimeZones();

      if (
        UserInfo.value?.CustomerInfo?.TimeZoneID ||
        UserInfo.value?.ContactInfo?.TimeZone
      ) {
        state.timeZone = !UserInfo.value?.CustomerInfo?.TimeZoneID
          ? timeZones.value.find(
            (itm) =>
              parseFloat(itm.code) ===
              parseFloat(UserInfo.value?.ContactInfo?.TimeZone)
          )?.code
          : timeZones.value.find(
            (itm) => itm.id === UserInfo.value?.CustomerInfo?.TimeZoneID
          )?.code;
      }

     // getPreEditCustomerInfo();
    });

    const isSubmitted = ref(false);

    const timeZoneService = ref(new TimeZoneService());
    const timeZones = ref();
    const customersService = new CustomersService();


    const state = reactive({
      firstNameVal: "",
      lastNameVal: "",
      emailVal: "",
      model: "",
      addressVal: "",
      country: UserInfo.value?.ContactInfo?.CountryCode || "AUS",
      timeZone: "W. Australia Standard Time_8",
      city: "",
      province: "",
      zipcode: ""
    });

    const rules = {
      firstNameVal: { required },
      lastNameVal: { required },
      emailVal: { required, email },
      country: { required },
      timeZone: { required },
      mobile: {},
    };

    const v$ = useVuelidate(rules, state);

    const onSubmit = async (isFormValid) => {
      isSubmitted.value = true;
      state.emailVal = state.emailVal.toLowerCase();
      if (!isFormValid) {
        return;
      }
    };




    watch(
      () => props.isOpened,
      (newVal, oldVal) => {
        if (oldVal === true) {
          emit("update:isOpened", false);
        }
      }
    );

    const getPreEditCustomerInfo = async () => {


      
      let data = {
        MajorToken: MajorToken.value,
        MinorToken: MinorToken.value
      };
      // if (props.f7route.query.customerCode) {
      //   data.Code = props.f7route.query.customerCode;
      //   state.code = props.f7route.query.customerCode;
      // }
      // isLoadingGetData.value = true;
     // let result = await customersService.getPreEditCustomerInfo(data);
      // isLoadingGetData.value = false;
      if (!result) return;

      







      // if (state.code && result.CustomerInfo) {
      //   setCustomerInfo(result.CustomerInfo);
      // }
      // if (state.code && result.ContactInfo) {
      //   setContactInfo(result.ContactInfo);
      // }
      if (
        (state.code && result.CustomerInfo?.TimeZoneID) ||
        (state.code && result.ContactInfo?.TimeZone)
      ) {
        state.timeZone = !result?.CustomerInfo?.TimeZoneID
          ? timeZones.value.find(
            itm =>
              parseFloat(itm.code) ===
              parseFloat(result.ContactInfo?.TimeZone)
          )?.code
          : timeZones.value.find(
            itm => itm.id === result.CustomerInfo?.TimeZoneID
          )?.code;
      }





    };

    return {
      onSubmit,
      state,
      v$,
      isSubmitted,

      timeZones,

      countries,
    };
  },
};
</script>